import SelectComponent from "../ui/select/SelectComponent";
import * as React from "react";
import AppointmentStatus from "../../model/appointment/AppointmentStatus";

export default class SelectAppointmentStatus extends SelectComponent<AppointmentStatus> {
	matchFilter(element: AppointmentStatus, filter: string): boolean {
		return element.value.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: AppointmentStatus): string {
		return element.id;
	}

	elementToString(element: AppointmentStatus) {
		return element.label;
	}

	onInputChange(value: string) {
		this.props.onInputChange(value);
	}
}